import {CancelToken} from 'axios';
import {TimezoneObject} from './timezones.types';
import apiV2Service from '../api/api-v2.service';

const basePath = 'Timezones';

const timezonesApi = {
  loadTimezones: async (cancelToken?: CancelToken) => {
    const { data } = await apiV2Service.executeGetRequest<Array<TimezoneObject>>(
      `${basePath}/GetAllTimezones`,
      {},
      {cancelToken},
    );

    return data;
  },
};

export default timezonesApi;
